<div class="payment" id="form-container">
  <div class="payment__sq-ccbox" id="sq-ccbox">
    <div class="payment__payment-form" *ngIf="isKioskForm(); else paymentForm">
      <p class="payment__card-phone">
        Please pay using the link sent to:
      </p>
      <p>{{this.userPhoneNumber}}</p>
      <button class="payment__payment-form--button" (click)="goToPhoneNumberPage()">
        Re-enter Phone
      </button>
      <button class="payment__payment-form--button" (click)="goToLastItemsPage()">
        Next Customer
      </button>
    </div>
    <div [hidden]="!showWallets || (showGiftCardForm && !isAdditional)|| sharedOrderId" class="walletbox">
      <div class="walletbox-text">
        <div class="walletbox-text__wrapper">
          <div class="walletbox-text__border"></div>
          <span class="walletbox-text__text">or</span>
          <div class="walletbox-text__border"></div>
        </div>
      </div>
      <div class="walletbox-buttons" (click)="changeForceTouched()">
        <ion-button class="apple-pay-button-with-text apple-pay-button-black-with-text" *ngIf="isBrowserSafari && !isCordova"
                    [style.pointer-events]="isDisabledWalletButtons ? 'none' : 'auto'"  (click)="walletPayment(nonceType.APPLE_PAY)"
                    expand="block" color="black" id="applePay">
          <span class="text">Check out with</span>
          <span class="logo"></span>
        </ion-button>
        <ion-button class="apple-pay-button-with-text apple-pay-button-black-with-text" *ngIf="isCanUseApplePay"
                    [style.pointer-events]="isDisabledWalletButtons ? 'none' : 'auto'"  (click)="walletPayment(nonceType.APPLE_PAY_NATIVE)"
                    expand="block" color="black" id="applePay">
          <span class="text">Check out with</span>
          <span class="logo"></span>
        </ion-button>
        <div [disabled]="reInitWallet" class="google-pay-button" [style.pointer-events]="isDisabledWalletButtons ? 'none' : 'auto'" id="googlePay" (click)="walletPayment(nonceType.GOOGLE_PAY)" *ngIf="!platform.is(isAndroid)"></div>
        <div [disabled]="reInitWallet" class="google-pay-button" [style.pointer-events]="isDisabledWalletButtons ? 'none' : 'auto'" id="googlePay" (click)="walletPayment(nonceType.GOOGLE_PAY_NATIVE)" *ngIf="platform.is(isAndroid) && isCanUseGooglePay"></div>
      </div>
    </div>

    <div *ngIf="allowUseGiftCard"
         class="swap-payment-button {{isLoading ? 'swap-payment-button-disabled' : ''}}" (click)="swapPaymentMethod()"
         [hidden]="isSourcePayment">
      {{!showGiftCardForm ? 'Use a gift card' : 'Use a different payment method'}}
    </div>
  </div>
</div>

<!-- ============ PAYMENT FORM TEMPLATE =========== -->
<ng-template #paymentForm>
  <form class="payment__payment-form" id="nonce-form">
    <div class="payment__payment-form--input-names-wrapper" *ngIf="isSavedCustomerWrongName && !showPaymentForm"
         [ngStyle]="hideSaveCard ? {'margin-top': '3rem'} : {}">
      <div class="payment__payment-form--input-wrapper payment__payment-form--input-name-wrapper">
        <input [hidden]="hideCustomerInfoField" type="text" name="givenName"
               class=" payment__payment-form--input"
               placeholder="First name" [(ngModel)]="givenName" maxlength="30" (ngModelChange)="changeGivenName()"/>
        <p class="payment__payment-form-error" *ngIf="isGivenNameInvalid && (touched || forceTouched)">
          Please enter a valid first name
        </p>
      </div>
      <div class="payment__payment-form--input-wrapper payment__payment-form--input-name-wrapper">
        <input [hidden]="hideCustomerInfoField" type="text" name="familyName"
               class="payment__payment-form--input"
               placeholder="Last name" [(ngModel)]="familyName" maxlength="30"
               (ngModelChange)="changeFamilyName()"/>
        <p class="payment__payment-form-error" *ngIf="isFamilyNameInvalid && (touched || forceTouched)">
          Please enter a valid last name
        </p>
      </div>
    </div>
    <div class="payment__payment-form--input-email-wrapper" *ngIf="isSavedCustomerWrongEmail && !showPaymentForm && !sharedOrderId">
      <div class="payment__payment-form--input-wrapper payment__payment-form--input-email-box-wrapper">
        <input [hidden]="hideCustomerInfoField" type="email" name="email"
               class="payment__payment-form--input"
               placeholder="Email" [(ngModel)]="email" maxlength="50" (ngModelChange)="changeEmail()"/>
        <p class="payment__payment-form-error" *ngIf="(!email || !isValidEmail) && (touched || forceTouched)">
          Please enter a valid email
        </p>
      </div>
    </div>
    <hr *ngIf="(isSavedCustomerWrongAddress && !showPaymentForm) || !sharedOrderId"/>
    <app-billing-address *ngIf="isSavedCustomerWrongAddress && !showPaymentForm && !sharedOrderId" [touched]="forceTouched"></app-billing-address>

    <app-saved-card *ngIf="!isSourcePayment && showCustomerCard && !sharedOrderId"
                    [cardId]="cardId"
                    [touched]="touched"
                    [isRemoveCard]="isRemoveCard"
                    [isSavedPayment]="savedPayment"
                    [isSharedCardsEnabled]="isSharedCardsEnabled"
                    (getCardId)="getCardId($event)"
                    (getIsRemoveCard)="getIsRemoveCard($event)"
                    (getSavedPayment)="getSavedPayment($event)"
                    (getTouched)="getTouched($event)"
    ></app-saved-card>
    <fieldset [hidden]="!showPaymentForm">
      <ion-text [hidden]="!paymentStore.createTabChecked" class="field__description">Enter your payment details to start a tab</ion-text>
      <div class="save-card" *ngIf="isLoaded && !isSendPayRequest" [hidden]="hideSaveCard || sharedOrderId">
        <ion-label color="main-dark" class="save-card__checkbox-text">
          Save card for future orders (recommended)
        </ion-label>
        <div (click)="showMobileSaveCardCheckboxMessage()" (mouseenter)="showSaveCardCheckboxMessage()" (mouseleave)="hideSaveCardCheckboxMessage()">
          <ion-checkbox color="main-dark" class="save-card__checkbox" name="save-card" [(ngModel)]="doSaveCard" [disabled]="saveCardCheckboxDisabled"></ion-checkbox>
        </div>
        <div class="save-card__tooltip" *ngIf="showCheckboxWarningMessage && saveCardCheckboxDisabled">
          <span class="save-card__tooltip-text">Orders with fulfillments from multiple locations require a card on file as we must break up the order into multiple sub-orders due to payment provider limitations. If you do not wish to save your card, please check out one location at a time.</span>
        </div>
      </div>
      <div class="save-card" *ngIf="isGiftCardPermission" [hidden]="!showGiftCardForm">
        <ion-label color="main-dark" class="save-card__checkbox-text">
          Save card for future orders
        </ion-label>
        <div>
          <ion-checkbox color="main-dark" class="save-card__checkbox" name="save-card" [(ngModel)]="doSaveGiftCard"></ion-checkbox>
        </div>
      </div>
      <div class="payment__payment-form--input-names-wrapper" [ngStyle]="hideSaveCard ? {'margin-top': '3rem'} : {}">
        <div class="payment__payment-form--input-wrapper payment__payment-form--input-name-wrapper">
          <input [hidden]="hideCustomerInfoField" type="text" name="givenName"
                 id="first-name"
                 class=" payment__payment-form--input"
                 placeholder="First name" [(ngModel)]="givenName" maxlength="30"
                 (ngModelChange)="changeGivenName()"/>
          <p class="payment__payment-form-error" *ngIf="!givenName && (touched || forceTouched)">
            Please enter a valid first name
          </p>
        </div>

        <div class="payment__payment-form--input-wrapper payment__payment-form--input-name-wrapper">
          <input [hidden]="hideCustomerInfoField" type="text" name="familyName"
                 id="last-name"
                 class="payment__payment-form--input"
                 placeholder="Last name" [(ngModel)]="familyName" maxlength="30"
                 (ngModelChange)="changeFamilyName()"/>
          <p class="payment__payment-form-error" *ngIf="!familyName && (touched || forceTouched)">
            Please enter a valid last name
          </p>
        </div>
      </div>
      <div class="payment__payment-form--input-email-wrapper" *ngIf="isEmailRequired && !sharedOrderId">
        <div class="payment__payment-form--input-wrapper payment__payment-form--input-email-box-wrapper">
          <ion-label color="main-dark" class="save-card__checkbox-text" *ngIf="isGroup">
            Please enter your email to receive your receipt.
          </ion-label>
          <input [hidden]="hideCustomerInfoField" type="email" name="email"
                 class="payment__payment-form--input"
                 id="email"
                 placeholder="Email" [(ngModel)]="email" maxlength="50" (ngModelChange)="changeEmail()"/>
          <p class="payment__payment-form-error" *ngIf="(!email || !isValidEmail) && (touched || forceTouched)">
            Please enter a valid email
          </p>
        </div>
      </div>
      <hr *ngIf="showBillingAddress && !sharedOrderId"/>
      <app-billing-address *ngIf="showBillingAddress && !sharedOrderId" [touched]="forceTouched"></app-billing-address>
      <hr/>
      <div class="gift-card-container" [hidden]="!showGiftCardForm">
        <ion-label color="main-dark" class="save-card__checkbox-text" *ngIf="isGiftBalance && giftCardBalance > 0">
          Using gift card balance (${{giftCardBalance}})
        </ion-label>
        <div class="card-content">
          <div id="gift-card"></div>
          <ng-container *ngIf="isGiftCardPermission">
            <div *ngIf="isSpinner; then spinner else button"></div>
            <ng-template #button>
              <button class="gift-btn" (click)="isGiftCardVerify? editGiftCard() : verifyGiftCard()">
                {{isGiftCardVerify? 'Edit': 'Apply'}}
              </button>
            </ng-template>
            <ng-template #spinner>
              <div class="spinner-wrapper">
                <app-spinner class="phone-spinner"></app-spinner>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <div class="card-container" [hidden]="!showCardForm || sharedOrderId">
        <div class="card-desc" *ngIf="isAdditional">
          <div class="field__title">Additional Payment Method
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-card"></use>
            </svg>
          </div>
          <ion-label color="main-dark" class="save-card__checkbox-text" *ngIf="isGiftBalance">
            This payment method will be charged the remaining balance ({{remainBalance | currency:'USD':'symbol-narrow'}})
          </ion-label>
        </div>
        <app-saved-card *ngIf="showSavedCardForSource"
                        [cardId]="cardId"
                        [touched]="touched"
                        [isRemoveCard]="isRemoveCard"
                        [isSavedPayment]="savedPayment"
                        [isSharedCardsEnabled]="isSharedCardsEnabled"
                        (getCardId)="getCardId($event)"
                        (getIsRemoveCard)="getIsRemoveCard($event)"
                        (getSavedPayment)="getSavedPayment($event)"
                        (getTouched)="getTouched($event)"
        ></app-saved-card>
        <div [hidden]="showSavedCardForSource && savedPayment" id="card"></div>
      </div>
    </fieldset>
  </form>
</ng-template>
